'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function Label(_ref) {
    var label = _ref.label,
        labelClassNames = _ref.labelClassNames,
        required = _ref.required,
        id = _ref.id;

    var mergedLabelClassNames = (0, _classnames2.default)('luna-label', labelClassNames, {
        'luna-label--fluid': required
    });
    return _react2.default.createElement("label", { className: mergedLabelClassNames, htmlFor: id }, label, required && _react2.default.createElement("span", { className: "luna-label__secondary" }, "Required field"));
};
Label.propTypes = {
    label: _propTypes2.default.string.isRequired,
    labelClassNames: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    required: _propTypes2.default.bool,
    id: _propTypes2.default.string.isRequired
};
Label.defaultProps = {
    required: false
};
exports.default = Label;
//# sourceMappingURL=Label.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Input/Label.js